// extracted by mini-css-extract-plugin
export default {"video":"YoutubeEmbed_video__uSNg2","iframe":"YoutubeEmbed_iframe__8e-KJ"};